(function () {
  'use strict';

  function initCanvas(canvas) {
    if (!canvas || canvas.dataset.dmimInit === '1') return;
    canvas.dataset.dmimInit = '1';

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var tint = canvas.dataset.tint || 'warm';
    var palette = tint === 'cool'
      ? { node: 'rgba(255,255,255,0.85)', line: 'rgba(154,51,36,0.35)', glow: 'rgba(69,75,88,0.5)' }
      : { node: 'rgba(255,255,255,0.85)', line: 'rgba(255,128,102,0.32)', glow: 'rgba(154,51,36,0.45)' };

    var w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var nodes = [];
    var running = false;
    var rafId = null;
    var lastT = 0;

    function resize() {
      var rect = canvas.getBoundingClientRect();
      w = Math.max(1, rect.width);
      h = Math.max(1, rect.height);
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var count = Math.round((w * h) / 26000);
      count = Math.max(14, Math.min(46, count));
      nodes = [];
      for (var i = 0; i < count; i++) {
        nodes.push({
          x: Math.random() * w,
          y: Math.random() * h,
          vx: (Math.random() - 0.5) * 14,
          vy: (Math.random() - 0.5) * 14,
          r: 1.4 + Math.random() * 1.8
        });
      }
    }

    function drawStatic() {
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = palette.node;
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        ctx.beginPath();
        ctx.arc(n.x, n.y, n.r, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    function tick(t) {
      if (!running) return;
      var dt = Math.min(0.05, (t - lastT) / 1000 || 0.016);
      lastT = t;

      ctx.clearRect(0, 0, w, h);

      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        n.x += n.vx * dt;
        n.y += n.vy * dt;
        if (n.x < -10) n.x = w + 10; else if (n.x > w + 10) n.x = -10;
        if (n.y < -10) n.y = h + 10; else if (n.y > h + 10) n.y = -10;
      }

      var linkDist = Math.max(90, Math.min(w, h) * 0.16);
      ctx.lineWidth = 1;
      for (var a = 0; a < nodes.length; a++) {
        for (var b = a + 1; b < nodes.length; b++) {
          var dx = nodes[a].x - nodes[b].x;
          var dy = nodes[a].y - nodes[b].y;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < linkDist) {
            var alpha = 1 - dist / linkDist;
            ctx.strokeStyle = palette.line.replace(/[\d.]+\)$/, (alpha * 0.55).toFixed(3) + ')');
            ctx.beginPath();
            ctx.moveTo(nodes[a].x, nodes[a].y);
            ctx.lineTo(nodes[b].x, nodes[b].y);
            ctx.stroke();
          }
        }
      }

      ctx.fillStyle = palette.node;
      for (var j = 0; j < nodes.length; j++) {
        var m = nodes[j];
        ctx.beginPath();
        ctx.arc(m.x, m.y, m.r, 0, Math.PI * 2);
        ctx.fill();
        ctx.beginPath();
        ctx.fillStyle = palette.glow;
        ctx.arc(m.x, m.y, m.r * 3, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = palette.node;
      }

      rafId = requestAnimationFrame(tick);
    }

    function start() {
      if (running) return;
      running = true;
      lastT = performance.now();
      if (reduceMotion) {
        drawStatic();
      } else {
        rafId = requestAnimationFrame(tick);
      }
    }
    function stop() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
    }

    resize();
    drawStatic();

    var ro = window.ResizeObserver ? new ResizeObserver(function () { resize(); }) : null;
    if (ro) ro.observe(canvas);
    else window.addEventListener('resize', resize);

    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) start(); else stop();
        });
      }, { threshold: 0.05 });
      io.observe(canvas);
    } else {
      start();
    }
  }

  function initAll() {
    document.querySelectorAll('.dmim-story__canvas').forEach(initCanvas);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
